import { render, staticRenderFns } from "./ucuslistGuncel.vue?vue&type=template&id=3b16f3b8&scoped=true&"
import script from "./ucuslistGuncel.vue?vue&type=script&lang=js&"
export * from "./ucuslistGuncel.vue?vue&type=script&lang=js&"
import style0 from "./ucuslistGuncel.vue?vue&type=style&index=0&id=3b16f3b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16f3b8",
  null
  
)

export default component.exports